import React, { type InputHTMLAttributes, useEffect, useMemo, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as EyeDisabledIcon } from '@pkg/assets/icons/v2/eye-disabled.svg';
import { ReactComponent as EyeIcon } from '@pkg/assets/icons/v2/eye.svg';

import './_Input.scss';

interface YatPasswordInputProps extends InputHTMLAttributes<HTMLInputElement> {
    classes?: string;
    isInvalid: boolean;
    errorLabel?: string;
}

const YatPasswordInput = ({ isInvalid, errorLabel, classes, ...props }: YatPasswordInputProps) => {
    const { t } = useTranslation(['account', 'translation', 'common']);
    const [invalid, setInvalid] = useState(false);
    const [isShowing, setIsShowing] = useState(false);
    const inputType = isShowing ? 'text' : 'password';

    useEffect(() => {
        setInvalid(isInvalid);
    }, [isInvalid]);

    function handleToggleClick() {
        setIsShowing(!isShowing);
    }

    const classNames = useMemo(() => {
        let classNames = 'yat-password-input';
        if (classes) classNames += ` ${classes}`;
        if (invalid) classNames += ` yat-input--invalid`;
        return classNames;
    }, [classes, invalid]);

    return (
        <div className={classNames}>
            <div className="yat-password-input__extra">
                <input
                    className="yat-password-input__input yat-input yat-labelled-input__input"
                    type={inputType}
                    placeholder={t('common:password')}
                    {...props}
                />
                <button className="yat-password-input__toggle" onClick={handleToggleClick} type="button">
                    {isShowing ? (
                        <EyeDisabledIcon className="yat-password-input__toggle__icon" />
                    ) : (
                        <EyeIcon className="yat-password-input__toggle__icon" style={{ opacity: 0.5 }} />
                    )}
                </button>
            </div>
            {invalid && errorLabel && <div className="yat-input__error-label">{errorLabel}</div>}
        </div>
    );
};

export default YatPasswordInput;
